/*
 * VUEX getters
 */
export const adminGetters = {
  getMicrosoftLogin(state) {
    return state.microsoftLogin
  },
  getGoogleLogin(state) {
    return state.googleLogin
  },
  getFeideLogin(state) {
    return state.feideLoginStatus
  },
  getEducatorEmail(state) {
    return state.educatoremail || ''
  },
  getLoginType(state) {
    return state.logintype || ''
  },
  getPicture(state) {
    return state.picture
  },
  getServerUrl(state) {
    return state.serverUrl
  },
  getRegistryUrl(state) {
    return state.registryUrl
  },
  getEduParams(state) {
    console.log('getEduParams got called')
    return state.eduParams
  },
  getEducatorInfo(state) {
    return state.educatorinfo
  },
  getEducatorUid(state) {
    return state.educatoruid
  },
  getOrgInfo(state) {
    return state.orginfo
  },
  getLoggedIn(state) {
    return state.loggedin
  },
  getAccessToken(state) {
    return state.accessToken
  },
  getServerAccessToken(state) {
    return state.serverAccessToken
  },
  getIdToken(state) {
    return state.idtoken
  },
  getAccessTokenExpires(state) {
    return state.accessTokenExpires
  },
  getDisplayName(state) {
    return state.displayName
  },
  getUserid(state) {
    return state.userid
  },
  getAffiliation(state) {
    return state.affiliation
  },
  getGroups(state) {
    return state.groups
  },
  getBGroups(state) {
    return state.bgroups
  },
  getUGroups(state) {
    return state.ugroups
  },
  getOrgGroups(state) {
    return state.orggroups
  },
  getFeideOrganisations(state) {
    return state.feideorganisations
  },
  getGrepKompetanseMaal(state) {
    return state.grepKompetanseMaal
  },
  getLearnerKmsData(state) {
    return state.learnerkmsdata
  },
  getShowIntro(state) {
    return state.showIntro
  },
  getLearnersHomeworkTime(state) {
    return state.learnerhomeworktime
  },
  getLearnersReadingTime(state) {
    return state.learnerreadingtime
  },
  getLearnersSchoolGroupAssesment(state) {
    return state.learnerschoolgroupassessment
  },
  getLearnersSubjectFromSchoolClassGroup(state) {
    return state.learnersubjectschoolclass
  },
  getLearnersSubjectAssesment(state) {
    return state.learnersubjectassessment
  },
  getLearnersDoughnutKmsData(state) {
    return state.setlearnersdoughnutkms
  },
  getSubjectWordCloudData(state) {
    return state.setsubjectwordcloud
  },
  getSearchDate(state) {
    return state.searchdate
  },
  getNewGroupSubject(state) {
    return state.groupSubject
  },
  getLearnersSubjectInformationContribution(state) {
    return state.learnerssubjectinformationcontribution
  },
  getUnreadNotesLearner(state) {
    return state.unreadnoteslearner
  },
  getUnreadNotesSubject(state) {
    return state.unreadnotessubject
  },
  getNumberOfUnreadNotes(state) {
    return state.numberofunreadnotes
  },
  getEducatorCurriculum(state) {
    return state.educatorcurriculum
  },
  getProudOfData(state) {
    return state.proudof
  },
  getAppSecret(state) {
    return state.appsecret
  },
  getSid(state) {
    return state.sid
  },
  getEnvironment(state) {
    return state.environment
  },
  getLearningEnvironment(state) {
    return state.learningenvironment
  },
  getSocialCommonGroup(state) {
    return state.socialcommongroupnroup
  },
  getSocialQuestions(state) {
    return state.socialquestions
  },
  getLearnerSocialMap(state) {
    return state.learnersocialmap
  },
  getPublicKey(state) {
    return state.publicKey
  },
  getLang(state) {
    return state.lang
  },
  getLanguage(state) {
    return state.lang
  },
  getLicense(state) {
    return state.license
  },
  getLogInProcess(state) {
    return state.loginprocess && !state.loggedin
  },
  getSsoProcess(state) {
    return state.ssoprocess
  },
  getActiveSubject(state) {
    return state.activesubject
  },
  getAssignmentTemplate(state) {
    return state.assignmentTemplate
  },
  /* ************************************** */
  /*        NEW DESIGN FROM NICHLAS         */
  /* ************************************** */
  getActiveNavItem(state) {
    return state.activeNav
  },
  getMenuTop(state) {
    return state.setmenutop
  },
  getLoggingIn(state) {
    return state.isloggingin
  },
  getSmallScreen(state) {
    return state.smallscreen
  },
  /* V4L */
  getWrittenAssignmentToBeAssessed(state) {
    return state.writtenassignmenttobeassessed
  },
  getAssignmentComments(state) {
    console.log('GET ASSIGNEMENT COMMENTS (%j)', state.assignmentcomments)
    return state.assignmentcomments
  },
  getGrammarFeedback(state) {
    return state.grammarfeedback
  },
  getNotAssessed(state) {
    return state.notassessed
  },
  getLearnerAssess(state) {
    return state.learnerassess
  },
  getOnlyV4L(state) {
    return state.onlyV4L
  },
  getPlagiarismScanId(state) {
    return state.plagiarismscanid
  },
  getPlagiarismData(state) {
    return state.plagiarismdata
  },
  getOpenGuidancePanel(state) {
    return state.openguidancepanel
  },
  getOne(state) {
    return state.addone
  },
  getLearnerWrittenAssignmentUid(state) {
    return state.learnerwrittenassignment
  },
  getAFLAssignmentsMap(state) {
    return state.aflassignmentsmap
  },
  clearGrammarFeedback(state) {
    state.grammarfeedback = []
  },
  clearAssignmentComments(state) {
    state.assignmentcomments = []
  },
  isExperimental(state) {
    return state.experimental
  },
  isOffDisabled(state) {
    return state.offDisabled
  },
  getAssignmentLanguage(state) {
    return state.assignmentlanguage
  },
  getCompetencyGoals(state) {
    return state.competencygoals
  },
  getToFromDate(state) {
    return state.toFromDate
  },
  getLanguageList() {
    return [
      {
        label: 'Norsk Bokmål',
        lang: 'nb',
        flag: 'nbFlag'
      },
      {
        label: 'Norsk Nynorsk',
        lang: 'nn',
        flag: 'nbFlag'
      },
      {
        label: 'Sámi',
        lang: 'se',
        flag: 'seFlag'
      },
      {
        label: 'Swedish',
        lang: 'sv',
        flag: 'svFlag'
      },
      {
        label: 'English',
        lang: 'en',
        flag: 'enFlag'
      },
      {
        label: 'German',
        lang: 'de',
        flag: 'deFlag'
      },
      {
        label: 'Spanish',
        lang: 'es',
        flag: 'esFlag'
      },
      {
        label: 'Italian',
        lang: 'it',
        flag: 'itFlag'
      },
      {
        label: 'French',
        lang: 'fr',
        flag: 'frFlag'
      },
      {
        label: 'Romanian',
        lang: 'ro',
        flag: 'roFlag'
      },
      {
        label: 'Czech',
        lang: 'cs',
        flag: 'csFlag'
      },
      {
        label: 'Portuguese',
        lang: 'pt',
        flag: 'ptFlag'
      },
      {
        label: 'Turkish',
        lang: 'tr',
        flag: 'trFlag'
      },
      {
        label: 'Latvian',
        lang: 'lv',
        flag: 'lvFlag'
      },
      {
        label: 'Lithuanian',
        lang: 'lt',
        flag: 'ltFlag'
      },
      {
        label: 'Finnish',
        lang: 'fi',
        flag: 'fiFlag'
      },
      {
        label: 'Polish',
        lang: 'pl',
        flag: 'plFlag'
      },
      {
        label: 'Dutch',
        lang: 'nl',
        flag: 'nlFlag'
      }
    ]
  },
  /* *************************** */
  /*  Google and Microsoft login */
  /* *************************** */
  getDomain(state) {
    return state.domain
  },
  /* Pure read of state.geteu. The value is written by setDomain() (which App.vue calls in
     beforeMount, before any route component exists) and refined by setEuUserInfo() /
     setFeideUserInfo() once the identity provider is known. It must never be derived here:
     every request payload sends `eu: this.geteu` straight from state, so a getter side effect
     meant the flag was only correct if some component happened to read getEU() first. */
  getEU(state) {
    return state.geteu
  }
}
